module.exports = __webpack_public_path__ + "img/tips.8f827c2.svg";